module.exports = __webpack_public_path__ + "static/media/helpcard_search.22c132b6.svg";